<template>
    <div class="mainContentAdmin" id="weblogCategories">
      <b-overlay :show="status" no-wrap fixed z-index="9999">
        <template v-slot:overlay>
          <div class="d-flex align-items-center">
            <b-spinner small type="grow" variant="dark" class="mx-1"></b-spinner>
            <b-spinner type="grow" variant="dark" class="mx-1"></b-spinner>
            <b-spinner small type="grow" variant="dark" class="mx-1"></b-spinner>
          </div>
        </template>
      </b-overlay>
      <div class="filters">
        <b-button v-if="getRole !='CalibrationLab'" variant="primary" @click="showModalFunction">افزودن </b-button>
      </div>
      <!-- <div v-if="items && items.length > 0" class="mainTable">
       <s-table
                    v-model="items"
                    @showEditModal="showEditModal"
                    @deleteItem="deleteItem"
                    :settings="settings"
                    :headers="headers"
                  />
    </div> -->
    <div v-if="items" class="mainTable">
        <table v-if="items.length > 0" class="table table-hover">
          <tr class="trHeader">
            <th>  شرح خدمات</th>
            <th>گستره</th>
            <th>توضيحات </th>
            <th>نوع</th>
            <th>قيمت</th>
          </tr>
          <tr class="trDetail" v-for="itemC in items" :key="itemC.id"  
          v-if="getRole =='CalibrationLab' && itemC.isActive == true ">          
            <td>
              {{ itemC.name_fa }}
            </td>
            <td>
              {{ itemC.range }}
            </td>
            <td>
              {{ itemC.description }}
            </td>
            <td>
              {{ itemC.calibrationType === 'Pressure' ? 'فشار' : (itemC.calibrationType === 'Temperature' ? 'دما' : '') }}
            </td>           
            <td>
              {{ itemC.price }}
            </td>              
          </tr>
          <tr class="trDetail" v-for="itemC in items" :key="itemC.id"  
          v-if="getRole !='CalibrationLab'  ">
            <td>
              {{ itemC.name_fa }}
            </td>
            <td>
              {{ itemC.range }}
            </td>
            <td>
              {{ itemC.description }}
            </td>
            <td>
              {{ itemC.calibrationType === 'Pressure' ? 'فشار' : (itemC.calibrationType === 'Temperature' ? 'دما' : '') }}
            </td>           
            <td>
              {{ itemC.price }}
            </td>
             <td class="handlerSUp" v-if="getRole !='CalibrationLab'">
              <b-button  variant="primary" @click="showEditModal(itemC.id)"
                >ويرايش
              </b-button>  
               <b-button
                variant="danger"
                @click="changeIsActive(itemC.id, !itemC.isActive)"
                v-if="itemC.isActive"
                >غیرفعال کردن</b-button
              >
              <b-button
                variant="success"
                @click="changeIsActive(itemC.id, !itemC.isActive)"
                v-else
                >فعال کردن</b-button
              > 
            </td>
          </tr>
        </table>
        <div class="noItems" v-else>
          <svg
            xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
            xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:osb="http://www.openswatchbook.org/uri/2009/osb"
            xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
            xmlns:cc="http://creativecommons.org/ns#"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xmlns:dc="http://purl.org/dc/elements/1.1/"
            xmlns:svg="http://www.w3.org/2000/svg"
            xmlns:ns1="http://sozi.baierouge.fr"
            id="svg2160"
            sodipodi:docname="OK-2.svg"
            viewBox="0 0 28.912 32.654"
            sodipodi:version="0.32"
            version="1.0"
            inkscape:output_extension="org.inkscape.output.svg.inkscape"
            inkscape:version="0.48.0 r9654"
          >
            <sodipodi:namedview
              id="base"
              fit-margin-left="0"
              inkscape:zoom="11"
              height="64px"
              borderopacity="1.0"
              inkscape:current-layer="layer1"
              inkscape:cx="10.569472"
              inkscape:cy="15.862443"
              fit-margin-right="2.7755576e-017"
              inkscape:grid-bbox="true"
              inkscape:window-maximized="0"
              showgrid="true"
              width="64px"
              inkscape:document-units="px"
              bordercolor="#666666"
              inkscape:window-x="137"
              inkscape:window-y="182"
              fit-margin-bottom="0"
              inkscape:window-width="1330"
              inkscape:pageopacity="0.0"
              inkscape:pageshadow="2"
              pagecolor="#ffffff"
              inkscape:window-height="900"
              fit-margin-top="0"
            />
            <g
              id="layer1"
              inkscape:label="Layer 1"
              inkscape:groupmode="layer"
              transform="translate(-20.653 -15.447)"
            >
              <path
                id="path3207"
                style="fill: #ff0000"
                inkscape:connector-curvature="0"
                d="m38.638 18.139c-1.798 1.5509-3.1446 4.3692-4.5312 5.8438-2.6315-2.177-3.8188-6.2358-6.6562-7.375-3.4407 0.91828-8.9042 4.1354-4.875 7.625 2.0576 3.0423 6.1945 5.7464 7.1562 8.9062-1.4673 3.7894-4.291 6.615-7.0312 9.375 1.3399 4.6754 7.7548 0.52478 10.344-1.75 2.0648-4.6338 3.5683 0.89824 5.4994 2.891 1.5405 6.2227 9.8042 4.4034 10.522-0.73944-2.8396-4.5489-6.7818-8.9244-9.521-13.402 1.0851-4.6542 5.6334-7.7704 6.6875-12.281-1.7893-3.1223-5.2813 0.35232-7.5938 0.90625z"
              />
              <path
                id="path3792"
                style="stroke: #a70000; fill: none"
                inkscape:connector-curvature="0"
                d="m38.638 18.139c-1.798 1.5509-3.1446 4.3692-4.5312 5.8438-2.6315-2.177-3.8188-6.2358-6.6562-7.375-3.4407 0.91828-8.9042 4.1354-4.875 7.625 2.0576 3.0423 6.1945 5.7464 7.1562 8.9062-1.4673 3.7894-4.291 6.615-7.0312 9.375 1.3399 4.6754 7.7548 0.52478 10.344-1.75 2.0648-4.6338 3.5683 0.89824 5.4994 2.891 1.5405 6.2227 9.8042 4.4034 10.522-0.73944-2.8396-4.5489-6.7818-8.9244-9.521-13.402 1.0851-4.6542 5.6334-7.7704 6.6875-12.281-1.7893-3.1223-5.2813 0.35232-7.5938 0.90625z"
              />
            </g>
            <metadata>
              <rdf:RDF>
                <cc:Work>
                  <dc:format>image/svg+xml</dc:format>
                  <dc:type
                    rdf:resource="http://purl.org/dc/dcmitype/StillImage"
                  />
                  <cc:license
                    rdf:resource="http://creativecommons.org/licenses/publicdomain/"
                  />
                  <dc:publisher>
                    <cc:Agent rdf:about="http://openclipart.org/">
                      <dc:title>Openclipart</dc:title>
                    </cc:Agent>
                  </dc:publisher>
                  <dc:title>red not OK / failure symbol</dc:title>
                  <dc:date>2011-09-20T10:43:26</dc:date>
                  <dc:description>red not OK / failure symbol</dc:description>
                  <dc:source
                    >https://openclipart.org/detail/161515/red-not-ok--failure-symbol-by-antares42</dc:source
                  >
                  <dc:creator>
                    <cc:Agent>
                      <dc:title>Antares42</dc:title>
                    </cc:Agent>
                  </dc:creator>
                  <dc:subject>
                    <rdf:Bag>
                      <rdf:li>OK</rdf:li>
                      <rdf:li>button</rdf:li>
                      <rdf:li>failure</rdf:li>
                      <rdf:li>green</rdf:li>
                      <rdf:li>icon</rdf:li>
                      <rdf:li>not OK</rdf:li>
                      <rdf:li>red</rdf:li>
                      <rdf:li>success</rdf:li>
                    </rdf:Bag>
                  </dc:subject>
                </cc:Work>
                <cc:License
                  rdf:about="http://creativecommons.org/licenses/publicdomain/"
                >
                  <cc:permits
                    rdf:resource="http://creativecommons.org/ns#Reproduction"
                  />
                  <cc:permits
                    rdf:resource="http://creativecommons.org/ns#Distribution"
                  />
                  <cc:permits
                    rdf:resource="http://creativecommons.org/ns#DerivativeWorks"
                  />
                </cc:License>
              </rdf:RDF>
            </metadata>
          </svg>
  
          <p>اطلاعاتی برای نمایش وجود ندارد</p>
        </div>
    </div>
    <div v-if="items != null && totalPages > 1">
      <div id="pagination">
        <pagination
          @pageChanged="pageChanged"
          :totalPages="totalPages"
          :currentPage="currentPage"
        />
      </div>
    </div>
      <b-modal
        id="blogModal"
        hide-footer
        ref="blogModal"
        no-close-on-backdrop
        v-model="showModal"
        @close="resetModal()"
        :title="mode == 'create' ? 'افزودن ' + title : ' ويرايش ' + title"
      >
        <s-inputs
          :disabled="disabled"
          @submit="submit"
          :mode="mode"
          :folderRoute="'calibrationLabs'"
          :bigData="bigData"
          :settings="settings"
          :headers="headers"
        />
      </b-modal>
      <!-- <b-modal
      id="editmodel"
      hide-footer
      ref="editmodel"
      no-close-on-backdrop
      v-model="editModel"
      @close="resetModal()"
      title="ويرايش"
    >
    <s-inputs
          :disabled="disabled"
          @submit="submit"
          :mode="mode"
          :folderRoute="'calibrationLabs'"
          :settings="settings"
          :headers="headers"
          :bigData="bigData"
        />
    </b-modal>   -->
    <!--           :bigData="bigData"
      <b-modal
      id="blogModal"
      hide-footer
      ref="blogModal"
      no-close-on-backdrop
      v-model="editModel"
      @close="resetModal()"
      :title="mode == 'create' ? 'افزودن ' + title : ' مشاهده ' + title"
    >
      <s-inputs
        :disabled="disabled"
        @submit="submit"
        :mode="mode"
        :folderRoute="'calibrationLabs'"
        :bigData="bigData"
        :settings="settings"
        :headers="headers"
      />
    </b-modal> -->
    </div>
  </template>
  <script>
  import pagination from "@/components/front/shared/pagination.vue";
  import SInputs from "@/components/admin/shared/sInputs.vue";
  import STable from "@/components/admin/shared/sTable.vue";
  import adminMixin from "@/libraries/adminController.js";
  import { BModal, BButton, BOverlay, BSpinner } from "bootstrap-vue";
  export default {
    mixins: [adminMixin],
    components: {
      SInputs,
      BModal,
      BButton,
      STable,
      BOverlay,
      BSpinner,
      pagination
    },
    data() {
      return {
       // settings: {},
     //  items:[],
      // totalPages:0,
        headers: [
          {
            style: "col-12",
            show_in_table: true,
            show_in_Form: true,
            placeholder: " شرح خدمات را وارد کنید",
            type: "string",
            multiData: true,
            name: "شرح خدمات",
            key: "name"
          },
          {
            style: "col-12",
            show_in_table: true,
            show_in_Form: true,
            placeholder: "گستره را وارد کنید",
            type: "string",
            multiData: false,
            name: "گستره",
            key: "range"
          },
          {
            style: "col-12",
            show_in_table: true,
            show_in_Form: true,
            placeholder: " توضيحات راوارد کنید",
            type: "description",
            multiData: false,
            name: "توضيحات",
            key: "description"
          },
          {
            style: "col-6",
            show_in_table: true,
            show_in_Form: true,
            placeholder: "قيمت را وارد کنید",
            type: "number",
            multiData: false,
            name: "قيمت",
            selectIN: "selectListType",
            key: "price"
          },
          {
            style: "col-6",
            show_in_table: false,
            show_in_Form: true,
            placeholder: "نوع را انتخاب کنید",
            type: "select",
            multiData: false,
            name: "نوع",
            multiple: false,
            selectIN: "selectListType",
            key: "calibrationType"
          }
         , {
            style: "col-12",
            show_in_table: true,
            show_in_Form: false,
            placeholder: "",
            type: "setting",
            name: "تنظیمات",
            multiData: false,
            key: "",
          //  innerRoute: "/admin-panel/product-feature",
            edit: true,
            delete: true,
            editLabel: "ویرایش"
          }
        ],
       pageSize: 10,
       bigData: {
        persian: {},
        english: {},
        both: {}
      },
        title: "آزمايشگاه كاليبراسيون",
         editedId: null,
         apiRoute: "CalibrationLab",
      // //  ,length:10
      //  // length:10

        //items: null,
        //apiRoute: "CalibrationLab/GetCalibrationLabList",
       // sendModal: false,
      //  editModel:false,
       // showModal: false,
        //status:false,
       // mode : "edit",
        //status: true,
        //itemEdit:null
        //item: null,
       // userId: null,
       // message: "",
       // currentPage: 1,
       // totalPages: 1,
      };
    },
    computed: {
    getRole() {
      if (this.$store.getters.getAdminPanelRole == null) {
        return "";
      } else {
        return this.$store.getters.getAdminPanelRole;
      }
    }
  },
    mounted() {
      if (this.$route.query.page) {
        this.currentPage = this.$route.query.page;
      } else {
        this.currentPage = 1;
      }
      //this.loadSettings([{ route: "CalibrationType", field: "title" }]);
  
        this.settings['selectListType']=[ {id:'1',label:'فشار'}, {id:'2',label:'دما'}]
      this.loadItems(this.currentPage);
      this.getId();
    },
    watch: {
      item(newVal) {
        this.bigData = newVal;
      }
    },
    methods: {
      // loadItems(page) {
      //   let header = {};
      //   header["Access-Control-Expose-Headers"] = "X-Pagination";
      //   this.$axios
      //     .get(this.apiRoute + `?PageNumber=${page}&PageSize=10`, header)
      //     .then((res) => {
      //       let paginationData = JSON.parse(res.headers["x-pagination"]);
      //       this.totalPages = paginationData.TotalPages;
      //       this.currentPage = paginationData.CurrentPage;
      //       this.status = false;
      //       this.items = res.data.data;
      //     });
      // },
    //  showEditModal(itemC) {
    //   this.editedId = itemC.id;
    //   //this.status = true;
    //   // this.$axios.get(`${this.apiRoute}/${itemC.id}`).then((response) => {
    //     this.$axios.get(`${this.apiRoute}/${itemC.id}`).then((response) => {
    //      this.item = response.data.data;//
    //     this.convertToBigData(response.data.data);
    //    });
    // //  this.mode = "edit";
    //   //this.showModal = true;
    //   this.editModel = true;
    //   // setTimeout(() => {
    //   //   document
    //   //     .getElementById("blogModal___BV_modal_content_")
    //   //     .removeAttribute("tabindex");
    //   // });
    // },
      // showDetail(item) {
      //   this.item = item;
      //   this.showModal = true;
      // },
    //   showEditModal(item) {
    //   this.item = item;
    //   this.showModal = true;
    // },
    // resetModal() {
    //   this.showModal = false;
    //   this.item = null;
    // },
      showModalFunction() {
        this.showModal = true;
        setTimeout(() => {
          document
            .getElementById("blogModal___BV_modal_content_")
            .removeAttribute("tabindex");
        });
      },
      changeIsActive(id, status) {
        this.$axios
          .post(`CalibrationLab/ChangeCalibrationLabIsActive?id=${id}`)
          .then((res) => {
            let findItem = this.items.find((item) => item.id == id);
            if (findItem) {
              findItem.isActive = status;
            }
            this.$toast.success(res.data.message);
          });
      },
    }
  };
  </script>
  <style></style>
  